module.exports = __webpack_public_path__ + "static/media/certificates_icons.3c4069b0.png";